import { Show, TextField } from "@refinedev/antd";
import { useShow } from "@refinedev/core";
import { Typography, Card, Descriptions } from "antd";

const { Title } = Typography;

export const WorkoutShow = () => {
    const { query } = useShow();
    const { data, isLoading } = query;
    const workout = data?.data?.data;

    return (
        <Show isLoading={isLoading}>
            <Card>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 20
                }}>
                    <Title level={3}>Workout Details</Title>
                </div>

                <Descriptions bordered column={1}>
                    <Descriptions.Item label="ID">
                        <TextField value={workout?.id} />
                    </Descriptions.Item>
                    <Descriptions.Item label="Name">
                        <TextField value={workout?.name} />
                    </Descriptions.Item>
                    <Descriptions.Item label="Description">
                        <TextField value={workout?.description} />
                    </Descriptions.Item>
                    <Descriptions.Item label="Created At">
                        <TextField value={new Date(workout?.createdAt).toLocaleString()} />
                    </Descriptions.Item>
                    <Descriptions.Item label="Updated At">
                        <TextField value={new Date(workout?.updatedAt).toLocaleString()} />
                    </Descriptions.Item>
                </Descriptions>
            </Card>
        </Show>
    );
}; 